<!--Drawers-->
<div id="kt_allocation-create__drawer" [perfectScrollbar]="{wheelPropagation: true, suppressScrollX: true}"
    class="offcanvas offcanvas-right p-10 activities-canvas activity-tab-padding">

    <app-activities-create-panel *ngIf="createFormVisible" (onCreated)="activityCreated()" [activityData]="activityData"
        (onClosePanel)="closeDrawer()" (onOpenFormPanel)="openFormPanel()">
    </app-activities-create-panel>
</div>

<div id="kt_show_forms__drawer" [perfectScrollbar]="{wheelPropagation: true, suppressScrollX: true}"
    class="offcanvas offcanvas-right p-10 activities-canvas activity-tab-padding">

    <app-activities-forms-panel (onCreated)="activityCreated()" (onOpenDefaultForm)="openDefaultActivityForm()"
        (onClosePanel)="closeDrawer()" (onCreated)="activityCreated()" (onOpenFormPanel)="openFormPanel()" *ngIf="showAvailableForms">
    </app-activities-forms-panel>
</div>

<!-- <div id="kt_selected_form__drawer" [perfectScrollbar]="{wheelPropagation: true, suppressScrollX: true}"
    class="offcanvas offcanvas-right p-10 activities-canvas activity-tab-padding">

    <app-activities-dynamic-form-panel [formDef]="selectedForm" (onEdited)="activityEdited()" (onClosePanel)="closeDrawer()" [formData]="formData"
        [activityName]="activityName" [activityDate]="activityDate">
    </app-activities-dynamic-form-panel>
</div> -->


<div id="kt_allocation-assign__drawer" [perfectScrollbar]="{wheelPropagation: true, suppressScrollX: true}"
    class="offcanvas offcanvas-right p-10  activities-edit-canvas activity-tab-padding">

    <app-activities-assign-panel *ngIf="dataLoaded"
    (onClosePanel)="closeDrawer()"
    (onListReload)="refreshList()"
    [activityData]="activityData"
        [allowedPersonnel]="allowedPersonnel" [allowedPlants]="allowedPlants" [allowedMaterials]="allowedMaterials"
        [variancesFromPlanReasons]="variancesFromPlanReasons" [assetsToBeAssigned]="assetsToBeAssigned"
        [cloneModal]="cloneModal" [context]="context">
    </app-activities-assign-panel>
</div>
<!--/Drawers -->
